import LinkService from 'mangools-commons/lib/services/LinkService';

import { LinkRefSources } from 'mangools-commons/lib/constants/LinkRefSources';

LinkService.source = LinkRefSources.SERPWATCHER_APP;
